import { useCallback } from 'react';

import { useWindowUnload } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { usePrompt } from 'libs/navigation';

export const useDefaultPrompt = (
  {
    readOnly,
    dirty,
    isSubmitting,
  }: { readOnly?: boolean; dirty?: boolean; isSubmitting?: boolean },
  onConfirm?: () => void
) => {
  const { t } = useTranslation();

  const editable = !readOnly;

  // Don't show prompt if submitting
  const shouldPrompt = !!dirty && !isSubmitting;

  const confirmIsChanged = useCallback(
    (f: () => void) => {
      if (!shouldPrompt) {
        f();
        // no changes to confirm
        return null;
      }
      // eslint-disable-next-line no-alert
      if (window.confirm(t('confirm.cancelSaveMessage'))) {
        f();
        // user confirmed
        return true;
      }
      // user cancelled
      return false;
    },
    [shouldPrompt, t]
  );

  useWindowUnload(
    (e) => {
      if (shouldPrompt && editable) {
        e.preventDefault();
        e.returnValue = '';
      }
    },
    () => {
      if (editable) {
        onConfirm?.();
      }
    }
  );
  usePrompt(
    t('confirm.cancelSaveMessage'),
    shouldPrompt && editable,
    onConfirm
  );

  return { confirmIsChanged };
};
